import { STORE_LOANS_INFORMATION } from 'ActionTypes/loans';

const initialState = {
  data: null,
};

export const storeLoansInformation = (state = initialState, action) => {
  switch (action.type) {
    case STORE_LOANS_INFORMATION:
      return {
        ...state,
        data: { ...state?.data, ...action.data.loansInformation },
      };
    default:
      return { ...state };
  }
};

export default storeLoansInformation;
